import React from 'react';
import { Link, LinkProps as ReactRouterLinkProps } from 'react-router-dom';
import styled from 'styled-components';

const PlainLink = styled(Link)`
    text-decoration: none;
    color: inherit;
`;

interface LinkProps extends ReactRouterLinkProps {
    wide?: boolean;
}

export const HoverLink = styled(({ wide, ...props }: LinkProps) => <Link {...props} />)`
    text-decoration: none;
    color: inherit;
    &:hover {
        text-decoration: underline;
    }
    ${({ wide }) => `
        ${wide ? `display: block;` : ``}
    `}
`;

export const TableCellLink = styled.th`
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export default PlainLink;
